module.exports = __webpack_public_path__ + "static/deep-simplicity-c45db57b9d3eeb2922e14fac4cf43dec.jpg";